import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { ACCOUNTS_API } from "./constants";
import queryKeys from "./queryKeys";

export interface AccountData {
  accountTitle: string;
  accountType: string;
  isActive: boolean;
  restrictionCode: string | null;
  marginType: string;
  accountRegistration: string;
}

export function useGetAccountDetails(
  accountNumber: string,
  options?: UseQueryOptions<AccountData, any>
) {
  const getAccountDetailsApi = `${getAppConfigSetting(
    "apiUrl"
  )}${ACCOUNTS_API}`;

  const accountDetailsUrl = (accountNumber: string) =>
    `${getAccountDetailsApi}/${accountNumber}`;
  const getAccountDetails = async () => {
    if (!accountNumber) {
      return null;
    }
    const { data } = await axios.get(accountDetailsUrl(accountNumber), {
      withCredentials: true,
    });
    return data;
  };
  return useQuery<AccountData, AxiosError>(
    [queryKeys.accountDetails, accountNumber],
    getAccountDetails,
    {
      enabled: false,
      ...options,
    }
  );
}
